import { IColor } from "@/consts/Colors";
import { FC } from "react";

interface Props {
  color: IColor;
}

const ColorGridTile: FC<Props> = ({ color }): JSX.Element => {
  return (
    <div className="flex flex-col items-center space-y-4 p-16">
      <div
        className="w-32 h-32 rounded-full border border-gray-100"
        style={{ background: color.style }}
      />
      <p className="text-2xs text-center">{color.name}</p>
    </div>
  );
};
export default ColorGridTile;
